const updatePrivacyPolicyCheckboxValue = require("../run/privacyPolicyCheckbox/updatePrivacyPolicyCheckboxValue");

/**
 * @param checkbox {HTMLInputElement}
 * @return {void}
 */
module.exports = function whenPrivacyPolicyCheckboxUpdates(checkbox) {
    updatePrivacyPolicyCheckboxValue(checkbox);
}